"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryWriteOffInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var QueryWriteOffInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(QueryWriteOffInfo, _super);
    function QueryWriteOffInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '消费券核销';
        _this.code = '300002';
        _this.desc = '消费券核销';
        _this.requestParams = new coupon_1.QueryWriteOffInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return QueryWriteOffInfo;
}(service_1.BaseService));
exports.QueryWriteOffInfo = QueryWriteOffInfo;
//# sourceMappingURL=queryWriteOffInfo.js.map